const staging = window.env?.REACT_APP_API_PATH ?? process.env.REACT_APP_API_PATH;
const prod = window.env?.REACT_APP_API_PROD_PATH ?? process.env.REACT_APP_API_PROD_PATH;
const python = window.env?.PYTHON_APP_API_PATH ?? process.env.PYTHON_APP_API_PATH;

const env = { 
    REACT_APP_API_PATH : staging,
    REACT_APP_API_PROD_PATH : prod ?? staging,
    REACT_APP_DEBUG : window.env?.REACT_APP_DEBUG ?? process.env.REACT_APP_DEBUG,  
    PYTHON_APP_API_PATH : python
}

export { env };